import * as z from 'zod'
import { schemaBoolish } from './zodUtils.js'
import { GetApiContract, PatchApiContract } from './ApiContract.js'
import { DInvestorListItem, DInvestorSingleItem, InvestorListItem, InvestorSingleItem } from '../Investors.js'

export const putInvestorSchema = z.object({
    amountInCash: z.coerce.string().nullish(),
    amountInPercentage: z.coerce.string().nullish(),
    id: z.string().optional(),
    name: z.string(),
    feeLevel: z.coerce.number().nullish(),
    investorAliasId: z.string().optional(),
    investorId: z.string().optional(),
    leo: schemaBoolish.nullish(),
    isSeller: schemaBoolish.nullish(),
    withoutRights: schemaBoolish.nullish(),
    putOption: schemaBoolish.nullish(),
    primaryGuarantor: schemaBoolish.optional(),
})

export const patchInvestorSchema = z.union([
    z.object({
        aliasId: z.string().optional(),
        primary: z.undefined().optional(),
        promote: z.string().optional(),
    }),
    z.object({
        aliasId: z.string().optional(),
        primary: z.string().optional(),
        promote: z.undefined().optional(),
    }),
])

export interface PatchInvestorRequest extends PatchApiContract {
    Body: z.infer<typeof patchInvestorSchema>
}

export interface GetInvestorSingleItemRequest extends GetApiContract {
    Response: DInvestorSingleItem
    ResponseJson: InvestorSingleItem
}

export interface GetInvestorListRequest extends GetApiContract {
    Response: Array<DInvestorListItem>
    ResponseJson: Array<InvestorListItem>
}
